/**
 * paypalOnboardingHelper.js
 *
 * Shared utilities for handling PayPal onboarding flows across
 * different contexts (gift claiming, pool acceptance, etc.)
 */

/**
 * Handle PayPal onboarding redirect after signup
 * Stores context in sessionStorage and redirects to PayPal
 *
 * @param {Object} onboardingResult - Result containing action_url from PayPal
 * @param {string} context - Context type: 'pool_acceptance' or 'gift_claim'
 * @param {Object} contextData - Additional data to store (e.g., token, claimToken, etc.)
 * @returns {boolean} - True if redirect happened, false otherwise
 */
export function handlePayPalOnboardingRedirect(onboardingResult, context, contextData = {}) {
  if (onboardingResult?.action_url) {
    // Store context for return flow
    sessionStorage.setItem('paypal_onboarding_context', context);
    sessionStorage.setItem('paypal_onboarding_data', JSON.stringify(contextData));

    // Redirect to PayPal onboarding
    window.location.href = onboardingResult.action_url;
    return true;
  }
  return false;
}

/**
 * Get stored onboarding context after returning from PayPal
 *
 * @returns {Object|null} - { context, data } or null if no context stored
 */
export function getPayPalOnboardingContext() {
  const context = sessionStorage.getItem('paypal_onboarding_context');
  const dataStr = sessionStorage.getItem('paypal_onboarding_data');

  if (!context) return null;

  return {
    context,
    data: dataStr ? JSON.parse(dataStr) : {},
  };
}

/**
 * Clear stored onboarding context
 */
export function clearPayPalOnboardingContext() {
  sessionStorage.removeItem('paypal_onboarding_context');
  sessionStorage.removeItem('paypal_onboarding_data');
}
